import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SharedButtonComponent } from './shared-button/shared-button.component';
import { SharedLogoComponent } from './shared-logo/shared-logo.component';
import { SharedIconButtonComponent } from './shared-icon-button/shared-icon-button.component';
import { SharedStepperComponent } from './shared-stepper/shared-stepper.component';
import { SharedHelpDialogComponent } from './shared-help-dialog/shared-help-dialog.component';
import { SharedInfoDialogComponent } from './shared-info-dialog/shared-info-dialog.component';
import { SharedErrorDialogComponent } from './shared-error-dialog/shared-error-dialog.component';
import { SharedProfileCircleComponent } from './shared-profile-circle/shared-profile-circle.component';
import { SharedInfoComponent } from './shared-info/shared-info.component';
import { SharedHorizBarComponent } from './shared-horiz-bar/shared-horiz-bar.component';
import { SharedVertBarComponent } from './shared-vert-bar/shared-vert-bar.component';
import { SharedCircleComponent } from './shared-circle/shared-circle.component';

@NgModule({
  declarations: [
    SharedButtonComponent,
    SharedLogoComponent,
    SharedIconButtonComponent,
    SharedStepperComponent,
    SharedHelpDialogComponent,
    SharedInfoDialogComponent,
    SharedErrorDialogComponent,
    SharedProfileCircleComponent,
    SharedInfoComponent,
    SharedHorizBarComponent,
    SharedVertBarComponent,
    SharedCircleComponent,
  ],
  imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule],
  exports: [
    SharedButtonComponent,
    SharedLogoComponent,
    SharedIconButtonComponent,
    SharedStepperComponent,
    SharedVertBarComponent,
    SharedHorizBarComponent,
    SharedProfileCircleComponent,
    SharedInfoComponent,
    SharedCircleComponent,
  ],
})
export class SharedModule {}
